export const ClearIcon = () => (
    <svg
        tabIndex={-1}
        focusable="false"
        className="svg-icon icon-weather"
        width="80px"
        height="80px"
        fill="none"
        viewBox="0 0 80 80"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g transform="translate(3.000000, 11.000000)">
            <path
                d="M46.105 13.78c.102.016.137.05.154.069.026.03.056.083.064.158a.287.287 0 01-.028.169c-.013.022-.04.063-.136.1C37.766 17.5 32.11 25.64 32.11 34.847c0 12.143 9.753 22.004 21.805 22.004 2.934 0 5.789-.585 8.438-1.708.095-.04.142-.03.167-.022a.287.287 0 01.137.102c.046.06.063.12.064.16 0 .024-.001.073-.064.155-4.863 6.286-12.303 10.03-20.353 10.03C28.06 65.568 16.5 53.92 16.5 39.534 16.5 25.147 28.06 13.5 42.303 13.5c1.281 0 2.551.094 3.802.28z"
                stroke="#717277"
                strokeWidth="3"
            />
        </g>
    </svg>
);
